export default function (Component) {
Component.options.__tip = "<p><code>FdCalendar</code> is still under heavy development. Things might break.</p>\n"
}